(() => {
  const selector = 'video[data-nh-deferred-autoplay]';
  const mobileQuery = window.matchMedia('(max-width: 767px)');

  const startVideo = (video) => {
    if (!video || video.dataset.nhVideoStarted === 'true') return;

    const sources = video.querySelectorAll('source[data-src]');
    if (!sources.length) return;

    video.dataset.nhVideoStarted = 'true';
    sources.forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });

    video.preload = 'auto';
    video.load();
    video.play().catch(() => {});
  };

  const scheduleVideo = (video) => {
    if (!video || video.dataset.nhVideoQueued === 'true') return;
    video.dataset.nhVideoQueued = 'true';

    const delay = mobileQuery.matches ? 2200 : 700;
    window.setTimeout(() => {
      video.dataset.nhVideoQueued = 'false';
      if (video.dataset.nhVideoVisible === 'true') startVideo(video);
    }, delay);
  };

  const waitForPageLoad = (video) => {
    if (video.dataset.nhWaitingForLoad === 'true') return;

    if (document.readyState === 'complete') {
      scheduleVideo(video);
      return;
    }

    video.dataset.nhWaitingForLoad = 'true';
    window.addEventListener('load', () => {
      video.dataset.nhWaitingForLoad = 'false';
      scheduleVideo(video);
    }, { once: true });
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.dataset.nhVideoVisible = 'true';
        if (entry.target.dataset.nhVideoStarted === 'true') {
          entry.target.play().catch(() => {});
        } else {
          waitForPageLoad(entry.target);
        }
      } else if (entry.target.dataset.nhVideoStarted === 'true') {
        entry.target.dataset.nhVideoVisible = 'false';
        entry.target.pause();
      } else {
        entry.target.dataset.nhVideoVisible = 'false';
      }
    });
  }, { rootMargin: '200px 0px', threshold: 0.05 });

  const observeVideos = (scope = document) => {
    scope.querySelectorAll(selector).forEach((video) => {
      if (video.dataset.nhVideoObserved === 'true') return;
      video.dataset.nhVideoObserved = 'true';
      observer.observe(video);
    });
  };

  observeVideos();

  document.addEventListener('shopify:section:load', (event) => {
    observeVideos(event.target);
  });

  ['pointerdown', 'touchstart', 'keydown'].forEach((eventName) => {
    window.addEventListener(eventName, () => {
      document.querySelectorAll(`${selector}[data-nh-video-observed="true"]`).forEach((video) => {
        const bounds = video.getBoundingClientRect();
        if (bounds.bottom > 0 && bounds.top < window.innerHeight) startVideo(video);
      });
    }, { once: true, passive: true });
  });
})();
